"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDate = exports.getTime = exports.getUnixTime = void 0;
const getUnixTime = (date = null) => Math.floor((0, exports.getTime)(date) / 1000);
exports.getUnixTime = getUnixTime;
const getTime = (date = null) => date ? date.getTime() : Date.now();
exports.getTime = getTime;
const getDate = () => new Date();
exports.getDate = getDate;
